import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import DataTable, {
  TableColumn,
} from "react-data-table-component";

import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  ProgressBar,
  Row,
  Spinner,
} from "react-bootstrap";

import {
  BsDiagram3,
  BsEye,
  BsExclamationTriangle,
  BsHddNetwork,
  BsSearch,
} from "react-icons/bs";

import InventarioService from "../../../Services/Catalogos/InventarioService";

import {
  DTODisponibilidadIP,
  DTOResumenDisponibilidadIP,
  FiltroSituacionIP,
} from "../../../DTO/Inventario/DTODisponibilidadIP";

const obtenerMensajeError = (error: unknown): string => {
  const errorAxios = error as {
    response?: {
      data?: {
        mensaje?: string;
      };
    };
    message?: string;
  };

  return (
    errorAxios.response?.data?.mensaje ??
    errorAxios.message ??
    "Ocurrió un error inesperado."
  );
};

const obtenerColorSituacion = (
  situacion: string
): string => {
  const valor = situacion.trim().toUpperCase();

  if (valor === "LIBRE") return "success";
  if (valor === "OCUPADA") return "primary";
  if (valor === "RESERVADA EN USO") return "danger";
  if (valor === "RESERVADA") return "secondary";
  if (valor === "FUERA DE RANGO") return "danger";

  return "dark";
};

const ReporteDisponibilidadIPs = () => {
  const [resumen, setResumen] =
    useState<DTOResumenDisponibilidadIP[]>([]);

  const [detalle, setDetalle] =
    useState<DTODisponibilidadIP[]>([]);

  const [segmentoSeleccionado, setSegmentoSeleccionado] =
    useState<DTOResumenDisponibilidadIP | null>(null);

  const [filtroSituacion, setFiltroSituacion] =
    useState<FiltroSituacionIP>("TODAS");

  const [busquedaIP, setBusquedaIP] =
    useState("");

  const [cargandoResumen, setCargandoResumen] =
    useState(true);

  const [cargandoDetalle, setCargandoDetalle] =
    useState(false);

  const [mensajeError, setMensajeError] =
    useState<string | null>(null);

  const cargarResumen = useCallback(async () => {
    setCargandoResumen(true);
    setMensajeError(null);

    try {
      const respuesta =
        await InventarioService
          .obtenerResumenDisponibilidadIPs();

      setResumen(respuesta.data);
    } catch (errorPeticion) {
      setMensajeError(
        obtenerMensajeError(errorPeticion)
      );
    } finally {
      setCargandoResumen(false);
    }
  }, []);

  useEffect(() => {
    void cargarResumen();
  }, [cargarResumen]);

  const abrirDetalle = async (
    segmento: DTOResumenDisponibilidadIP
  ) => {
    setSegmentoSeleccionado(segmento);
    setDetalle([]);
    setFiltroSituacion("TODAS");
    setBusquedaIP("");
    setCargandoDetalle(true);
    setMensajeError(null);

    try {
      const respuesta =
        await InventarioService
          .obtenerDisponibilidadIPsPorSegmento(
            segmento.idSegmento,
            null
          );

      setDetalle(respuesta.data);
    } catch (errorPeticion) {
      setSegmentoSeleccionado(null);

      setMensajeError(
        obtenerMensajeError(errorPeticion)
      );
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarDetalle = () => {
    if (cargandoDetalle) return;

    setSegmentoSeleccionado(null);
    setDetalle([]);
    setFiltroSituacion("TODAS");
    setBusquedaIP("");
  };

  const totales = useMemo(
    () =>
      resumen.reduce(
        (acumulado, segmento) => ({
          asignables:
            acumulado.asignables +
            segmento.ipsAsignables,

          ocupadas:
            acumulado.ocupadas +
            segmento.ipsOcupadas,

          libres:
            acumulado.libres +
            segmento.ipsLibres,

          incidencias:
            acumulado.incidencias +
            segmento.ipsReservadasEnUso +
            segmento.ipsFueraDeRango,
        }),
        {
          asignables: 0,
          ocupadas: 0,
          libres: 0,
          incidencias: 0,
        }
      ),
    [resumen]
  );

  const detalleFiltrado = useMemo(() => {
    const texto =
      busquedaIP.trim().toLowerCase();

    return detalle.filter((direccion) => {
      const situacion =
        direccion.situacion.toUpperCase();

      // const cumpleSituacion =
      //   filtroSituacion === "TODAS" ||
      //   (
      //     filtroSituacion === "LIBRES" &&
      //     direccion.disponible
      //   ) ||
      //   (
      //     filtroSituacion === "OCUPADAS" &&
      //     situacion === "OCUPADA"
      //   ) ||
      //   (
      //     filtroSituacion === "RESERVADAS" &&
      //     direccion.reservada
      //   );

        const cumpleSituacion =
  filtroSituacion === "TODAS" ||
  (
    filtroSituacion === "LIBRES" &&
    direccion.disponible
  ) ||
  (
    filtroSituacion === "OCUPADAS" &&
    situacion === "OCUPADA"
  ) ||
  (
    filtroSituacion === "RESERVADAS" &&
    direccion.reservada
  ) ||
  (
    filtroSituacion === "FUERA_RANGO" &&
    situacion === "FUERA DE RANGO"
  );





      if (!cumpleSituacion) return false;

      if (!texto) return true;

      return [
        direccion.direccionIP,
        direccion.situacion,
        direccion.motivoReserva,
        direccion.nombreEquipo,
      ]
        .filter(Boolean)
        .some((valor) =>
          String(valor)
            .toLowerCase()
            .includes(texto)
        );
    });
  }, [busquedaIP, detalle, filtroSituacion]);

  const columnasResumen =
    useMemo<TableColumn<DTOResumenDisponibilidadIP>[]>(
      () => [
        {
          name: "Segmento",
          sortable: true,
          grow: 1.5,
          selector: (fila) =>
            fila.nombreSegmento,
          cell: (fila) => (
            <div>
              <div className="fw-bold">
                {fila.nombreSegmento}
              </div>

              <Badge bg="light" text="dark">
                {fila.tipoRed}
              </Badge>
            </div>
          ),
        },
        {
          name: "Rango / Gateway",
          grow: 1.5,
          cell: (fila) => (
            <div className="small">
              <div className="font-monospace fw-semibold">
                {fila.segmento}
              </div>

              <div className="text-muted">
                Gateway: {fila.gateway ?? "—"}
              </div>
            </div>
          ),
        },
        {
          name: "Asignables",
          sortable: true,
          center: true,
          selector: (fila) =>
            fila.ipsAsignables,
        },
        {
          name: "Ocupadas",
          sortable: true,
          center: true,
          selector: (fila) =>
            fila.ipsOcupadas,
          cell: (fila) => (
            <Badge bg="primary">
              {fila.ipsOcupadas}
            </Badge>
          ),
        },
        {
          name: "Libres",
          sortable: true,
          center: true,
          selector: (fila) =>
            fila.ipsLibres,
          cell: (fila) => (
            <Badge bg="success">
              {fila.ipsLibres}
            </Badge>
          ),
        },
        {
          name: "Ocupación",
          sortable: true,
          grow: 1.2,
          selector: (fila) =>
            fila.porcentajeOcupacion,
          cell: (fila) => (
            <div style={{ width: "100%" }}>
              <div className="small text-center mb-1">
                {fila.porcentajeOcupacion.toFixed(2)}%
              </div>

              <ProgressBar
                now={fila.porcentajeOcupacion}
                variant={
                  fila.porcentajeOcupacion >= 80
                    ? "danger"
                    : fila.porcentajeOcupacion >= 60
                    ? "warning"
                    : "success"
                }
                style={{ height: 7 }}
              />
            </div>
          ),
        },
        {
          name: "Alertas",
          center: true,
          cell: (fila) => {
            const incidencias =
              fila.ipsReservadasEnUso +
              fila.ipsFueraDeRango;

            return incidencias > 0 ? (
              <Badge bg="warning" text="dark">
                <BsExclamationTriangle className="me-1" />
                {incidencias}
              </Badge>
            ) : (
              <Badge bg="success">0</Badge>
            );
          },
        },
        {
          name: "Detalle",
          center: true,
          cell: (fila) => (
            <Button
              size="sm"
              variant="outline-primary"
              title="Ver disponibilidad"
              onClick={() =>
                void abrirDetalle(fila)
              }
            >
              <BsEye className="me-1" />
              Ver
            </Button>
          ),
        },
      ],
      []
    );

  const columnasDetalle =
    useMemo<TableColumn<DTODisponibilidadIP>[]>(
      () => [
        {
          name: "Dirección IP",
          sortable: true,
          grow: 1.2,
          selector: (fila) =>
            fila.direccionIP,
          cell: (fila) => (
            <span className="font-monospace fw-semibold">
              {fila.direccionIP}
            </span>
          ),
        },
        {
          name: "Situación",
          sortable: true,
          selector: (fila) =>
            fila.situacion,
          cell: (fila) => (
            <Badge
              bg={obtenerColorSituacion(
                fila.situacion
              )}
            >
              {fila.situacion}
            </Badge>
          ),
        },
        {
          name: "Motivo",
          grow: 1.2,
          selector: (fila) =>
            fila.motivoReserva ?? "",
          cell: (fila) =>
            fila.motivoReserva ?? "—",
        },
        {
          name: "Equipo",
          grow: 1.5,
          selector: (fila) =>
            fila.nombreEquipo ?? "",
          cell: (fila) => (
            <div>
              <div>
                {fila.nombreEquipo ?? "—"}
              </div>

              {fila.idEquipo && (
                <div className="text-muted small">
                  Equipo #{fila.idEquipo}
                </div>
              )}
            </div>
          ),
        },
        {
          name: "Principal",
          center: true,
          cell: (fila) =>
            fila.esPrincipal ? (
              <Badge bg="info">Sí</Badge>
            ) : (
              "—"
            ),
        },
      ],
      []
    );

  const estilosTabla = {
    headCells: {
      style: {
        color: "#64748b",
        fontSize: "11px",
        fontWeight: 700,
        textTransform: "uppercase" as const,
      },
    },
    rows: {
      style: {
        minHeight: "58px",
        fontSize: "13px",
      },
    },
  };

  return (
    <div>
      {mensajeError && (
        <Alert
          variant="danger"
          dismissible
          onClose={() =>
            setMensajeError(null)
          }
        >
          {mensajeError}
        </Alert>
      )}

      <div
        className="d-flex align-items-center gap-3 mb-3"
        style={{
          background: "#ffffff",
          padding: "14px 20px",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-3"
          style={{
            width: 42,
            height: 42,
            color: "#2563eb",
            backgroundColor: "#eff6ff",
          }}
        >
          <BsDiagram3 size={21} />
        </div>

        <div>
          <div className="fw-bold">
            Disponibilidad de direcciones IP
          </div>

          <div
            className="text-muted"
            style={{ fontSize: 12 }}
          >
            Direcciones libres, ocupadas y reservadas
          </div>
        </div>
      </div>

      <Row className="g-3 mb-3">
        <Col xs={12} md={6} xl={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="text-muted small fw-semibold">
                IP asignables
              </div>

              <div
                className="fw-bold"
                style={{ fontSize: 26 }}
              >
                {totales.asignables}
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="text-muted small fw-semibold">
                IP ocupadas
              </div>

              <div
                className="fw-bold text-primary"
                style={{ fontSize: 26 }}
              >
                {totales.ocupadas}
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="text-muted small fw-semibold">
                IP libres
              </div>

              <div
                className="fw-bold text-success"
                style={{ fontSize: 26 }}
              >
                {totales.libres}
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="text-muted small fw-semibold">
                Advertencias
              </div>

              <div
                className="fw-bold text-warning"
                style={{ fontSize: 26 }}
              >
                {totales.incidencias}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card
        className="border-0 shadow-sm"
        style={{
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <Card.Header className="bg-white fw-bold py-3">
          <BsHddNetwork className="me-2 text-primary" />
          Resumen por segmento
        </Card.Header>

        <Card.Body className="p-0">
          <DataTable
            columns={columnasResumen}
            data={resumen}
            customStyles={estilosTabla}
            progressPending={cargandoResumen}
            progressComponent={
              <div className="py-5">
                <Spinner
                  animation="border"
                  variant="primary"
                />
              </div>
            }
            pagination
            highlightOnHover
            responsive
          />
        </Card.Body>
      </Card>

      <Modal
        show={segmentoSeleccionado !== null}
        onHide={cerrarDetalle}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">
            <BsDiagram3 className="me-2 text-primary" />
            {segmentoSeleccionado?.nombreSegmento}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{ backgroundColor: "#f8fafc" }}
        >
          <Row className="g-3 mb-3">
            <Col xs={12} md={8}>
              <Form.Label className="small fw-semibold">
                Buscar dirección o equipo
              </Form.Label>

              <div className="position-relative">
                <BsSearch
                  className="position-absolute text-muted"
                  style={{
                    left: 12,
                    top: 12,
                  }}
                />

                <Form.Control
                  value={busquedaIP}
                  onChange={(event) =>
                    setBusquedaIP(event.target.value)
                  }
                  placeholder="Dirección IP, situación o equipo..."
                  style={{ paddingLeft: 36 }}
                />
              </div>
            </Col>

            <Col xs={12} md={4}>
              <Form.Label className="small fw-semibold">
                Situación
              </Form.Label>

              <Form.Select
                value={filtroSituacion}
                onChange={(event) =>
                  setFiltroSituacion(
                    event.target
                      .value as FiltroSituacionIP
                  )
                }
              >
                <option value="TODAS">Todas</option>
                <option value="LIBRES">Libres</option>
                <option value="OCUPADAS">Ocupadas</option>
                <option value="RESERVADAS">
                  Reservadas
                </option>
                <option value="FUERA_RANGO">
  Fuera de rango
</option>
              </Form.Select>
            </Col>
          </Row>

          <Card className="border-0 shadow-sm">
            <Card.Body className="p-0">
              <DataTable
                columns={columnasDetalle}
                data={detalleFiltrado}
                customStyles={estilosTabla}
                progressPending={cargandoDetalle}
                progressComponent={
                  <div className="py-5">
                    <Spinner
                      animation="border"
                      variant="primary"
                    />
                  </div>
                }
                pagination
                paginationPerPage={25}
                paginationRowsPerPageOptions={[
                  25,
                  50,
                  100,
                  250,
                ]}
                highlightOnHover
                responsive
                noDataComponent={
                  <div className="py-5 text-muted">
                    No se encontraron direcciones.
                  </div>
                }
              />
            </Card.Body>
          </Card>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={cerrarDetalle}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReporteDisponibilidadIPs;